interface prmDataInf {
  prmName: string;
  value1: string;
  value2: string;
  value3: string;
}

const steps = [
  "welcome",
  "limitedStep1",
  "limitAndPaymentInformation",
  "acceptance",
  "kvkk",
  "documents",
  "success",
];

const steps4EasyCep = [
  "welcome",
  "easycepStep1",
  "limitAndPaymentInformation",
  "acceptance",
  "kvkk",
  "documents",
  "success",
];

export const linksStates = {
  WAIT_APPLICANT: "0",
  REFUSE: "1",
  WAIT_LIMIT_APPROVE: "2",
  WAIT_TO_BE_CUSTOMER: "3",
  WAIT_USED: "4",
  USED: "5",
  LIMIT_NOT_ENOUGH: "6",
  KILLED: "7",
  HOLD: "8",
};

export enum EasyCepCustomerStatuStates {
  POTENTIAL_WITHOUT_APPROVED_AMOUNT = "0", //- Potansiyel ve limiti yok
  CUSTOMER_WITH_APPROVED_AMOUNT = "1", //- Müşterimiz ve limiti var
  CUSTOMER_WITHOUT_APPROVED_AMOUNT = "2", // - Müşterimiz limiti yok
  POTENTIAL_WITH_APPROVED_AMOUNT = "3", // - Potansiyel ve limiti var
}

export let prmData: prmDataInf[] = [];

export const infoTexts = {
  BM0001:
    "Ödemenizde kullanabileceğiniz kredi seçeneklerini aşağıda görüntüleyebilirsiniz." +
    " Size en uygun kredi türü ve ödeme seçeneklerini seçiniz.",
  BM0002: " tarihine kadar geçerli kredi limitiniz ",
  BM0003_PREFIX:
    "Sigorta seçiminize göre limit ve faiz oranı değişebilir. Bu tutar, belirtilen faiz oranıyla ",
  BM0003_SUFFIX: "kullanabileceğiniz sigortalı limitinizdir.",
};

export const PrmDataProperties = {
  ERROR_CODES: {
    prmName: "PRM_KRD_SME_ERROR_MESSAGES",
    value1: "TYPE",
    value2: "ERRORCODE",
    value3: "ERRORMESSAGE",
  },
  PRM_INSURANCE_GUARANTEE: {
    prmName: "PRM_INSURANCE_GUARANTEE",
    value1: "GUARANTEECODE",
    value2: "GUARANTEENAME",
  },
};

export const stateHandler = (stateCode: string, step: string) => {
  switch (stateCode) {
    case linksStates.WAIT_APPLICANT:
      return { result: "0", nextStatus: false };
    case linksStates.REFUSE:
      return { result: "1", nextStatus: true, errorCode: "MS0001" };
    case linksStates.WAIT_LIMIT_APPROVE:
      return { result: "2", nextStatus: true, errorCode: "MS0002" };
    case linksStates.WAIT_TO_BE_CUSTOMER:
      if (step === "simulationCreated") {
        return { result: "3", nextStatus: true, errorCode: "MS0024" };
      } else {
        return { result: "0", nextStatus: false };
      }
    case linksStates.WAIT_USED:
      return { result: "0", nextStatus: false };
    case linksStates.USED:
      return { result: "4", nextStatus: true, errorCode: "MS0015" };
    case linksStates.LIMIT_NOT_ENOUGH:
      return { result: "1", nextStatus: true, errorCode: "MS0018" };
    case "99":
      return { result: "1", nextStatus: true, errorCode: "MS0023" };
  }
};

export const getNextStep = (stepName: string, result: any) => {
  const currentIndex = steps.indexOf(stepName);
  if (result === "1") {
    return "unsuccess";
  } else if (result === "2") {
    return "waiting";
  } else if (result === "3") {
    return "customerQR";
  } else if (result === "4") {
    return "success";
  }

  return steps[currentIndex + 1];
};

export const getNextStep4Easycep = (stepName: string, result: any) => {
  const currentIndex = steps4EasyCep.indexOf(stepName);
  if (result === "1") {
    return "unsuccess";
  } else if (result === "2") {
    return "waiting";
  } else if (result === "3") {
    return "customerQR";
  } else if (result === "4") {
    return "success";
  }
  return steps4EasyCep[currentIndex + 1];
};

export const getPreviousStep = (stepName: string) => {
  const currentIndex = steps.indexOf(stepName);

  return steps[currentIndex - 1];
};

export const setPrmData = (arr: prmDataInf[]) => {
  prmData = arr;
};

export const getErrorMessage = (errCode: string) => {
  const prmMessage = prmData.find((val) => val.value2 === errCode)?.value3;
  return prmMessage;
};

export const getErrorCodeFromResultCode = (resultCode: string) => {
  const resultCodeMap: { [key: string]: string } = {
    "1239": "MS0030", // Boş değer ataması hatası
  };

  return resultCodeMap[resultCode];
};

export const getDocumentName = (documentCode: string) => {
  return prmData.find((val) => val.value1 === documentCode)?.value2;
};

export const getGuarantorDesc = (guarantorCode: string) => {
  let idx = prmData.findIndex(
    (val) => val.prmName === "PRM_INSURANCE_GUARANTEE",
  );
  return prmData.find(
    (val, index) => index >= idx && val.value1 === guarantorCode,
  )?.value2;
};

export const getDDMMYYYYFromYYYYMMDD = (str: string) => {
  if (str.length !== 8) {
    return str;
  }
  return (
    str.substring(6, 8) + "." + str.substring(4, 6) + "." + str.substring(0, 4)
  );
};

export const getNumberFormat = (num: string) => {
  try {
    const afterComma = num.split(".")[1] || "00";
    const beforeComma = num.split(".")[0];

    const numWDot = beforeComma
      .split("")
      .reverse()
      .map((el, idx) => {
        if (idx !== 0 && (idx + 1) % 3 === 0) {
          if (beforeComma.length === idx + 1 && beforeComma.length % 3 === 0)
            return el;
          return "." + el;
        }
        return el;
      })
      .reverse()
      .join("");

    return numWDot + "," + afterComma;
  } catch (err) {
    return num;
  }
};

export const getNumberFormatWithComma = (num: string) => {
  try {
    const afterComma = num.split(",")[1]
      ? num.split(",")[1].substring(0, 2)
      : "00";
    const beforeComma = num.split(",")[0];

    const numWDot = beforeComma
      .split("")
      .reverse()
      .map((el, idx) => {
        if (idx !== 0 && (idx + 1) % 3 === 0) {
          if (beforeComma.length === idx + 1 && beforeComma.length % 3 === 0)
            return el;
          return "." + el;
        }
        return el;
      })
      .reverse()
      .join("");

    return numWDot + "," + afterComma;
  } catch (err) {
    return num;
  }
};

export const getRandomInt = (min: number, max: number): number => {
  // Create byte array and fill with 1 random number
  var byteArray = new Uint8Array(1);
  window.crypto.getRandomValues(byteArray);

  var range = max - min + 1;
  var max_range = 256;
  if (byteArray[0] >= Math.floor(max_range / range) * range)
    return getRandomInt(min, max);
  return min + (byteArray[0] % range);
};

export const getProductTypeString = (productType: string) => {
  if (productType === "0") {
    return "Tarım";
  } else if (productType === "1") {
    return "Ticari";
  } else {
    return "";
  }
};

export const getFirmRedirectUrlFromShopUrl = (shopUrl: string | null) => {
  if (!shopUrl || typeof shopUrl !== "string") {
    return null;
  }
  const urls = shopUrl.split(";").map((url) => (url || "").trim());

  if (urls.length < 4) {
    return null;
  }
  const targetUrl = urls[3];

  if (!targetUrl) {
    return null;
  }
  const normalizedValue = targetUrl.toLowerCase();

  if (normalizedValue === "null" || normalizedValue === "undefined") {
    return null;
  }

  return targetUrl;
};
